import { render, staticRenderFns } from "./InvestorBusinessAddressDocument.vue?vue&type=template&id=1faed946&"
import script from "./InvestorBusinessAddressDocument.vue?vue&type=script&lang=js&"
export * from "./InvestorBusinessAddressDocument.vue?vue&type=script&lang=js&"
import style0 from "./InvestorBusinessAddressDocument.vue?vue&type=style&index=0&id=1faed946&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports